import { AuthorizationService } from "src/app/services/authorization.service";

export class TemplateDetailsActionItemsHelper {
  public showAction: string;
  public currentActionItems = [];
  public canAddEdit: boolean = true;
  private readonly ACTION_ITEMS = [
    {
      feature: 'ContractManagement::AddEditTemplate',
      item: {
        label: 'Edit Industry Contract Template Details',
        name: 'editTemplateDetails',
        tip: 'Edit Industry Template Details',
        icon: '#inm-icon__edit',
        disabled: !this.canAddEdit,
        show: true,
      },
    },
  ];

  constructor(private authService: AuthorizationService) {
    this.generateToolbarData();
  }

  generateToolbarData(): void {
    for (const actions of this.ACTION_ITEMS) {
      if (!actions.feature) {
        this.currentActionItems.push(actions.item);
        continue;
      }
      if (actions.feature && this.authService.hasFeature(actions.feature)) {
        this.currentActionItems.push(actions.item);
      }
    }
  }
}
